import { render } from "./PatientsIcon.vue?vue&type=template&id=2c0865e3"
import script from "./PatientsIcon.vue?vue&type=script&lang=js"
export * from "./PatientsIcon.vue?vue&type=script&lang=js"

import exportComponent from "/builds/check-marq/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__